module.exports = __webpack_public_path__ + "static/co-pay-card-f3c41a4cbd56559a83cf3a452bab5f0f.svg";